import { render, staticRenderFns } from "./DuplicacionIndex.vue?vue&type=template&id=652ba5dc&scoped=true"
import script from "./DuplicacionIndex.vue?vue&type=script&lang=ts"
export * from "./DuplicacionIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ba5dc",
  null
  
)

export default component.exports